// src/mappers/sale/quotation/quotationDetailToFormMapper.ts

export const quotationDetailToFormMapper = (
    quotation: any
) => {

    return {

        id: quotation.id,

        // ==========================
        // 🔹 Customer
        // ==========================

        customer: quotation.customerId
            ? {
                id: quotation.customerId,
                name: quotation.customerName
            }
            : null,

        // ==========================
        // 🔹 Seller
        // ==========================

        seller: quotation.sellerId
            ? {
                id: quotation.sellerId,
                name: quotation.sellerName
            }
            : null,

        // ==========================
        // 🔹 Branch
        // ==========================

        branch: quotation.branchId
            ? {
                id: quotation.branchId,
                name: quotation.branchName
            }
            : null,

        // ==========================
        // 🔹 Dates
        // ==========================

        expirationDate:
            quotation.expirationDate ?? "",

        // ==========================
        // 🔹 Extras
        // ==========================

        notes:
            quotation.notes ?? "",

        // ==========================
        // 🔹 Condición de pago / crédito
        // ==========================

        paymentCondition: quotation.paymentConditionId
            ? {
                id: quotation.paymentConditionId,
                name: quotation.paymentConditionName,
                code: quotation.paymentConditionCode,
                termId: quotation.termId ?? undefined,
                termName: quotation.termName ?? undefined,
                termCode: quotation.termCode ?? undefined,
                creditDays: quotation.creditDays ?? undefined,
                creditMonths: quotation.creditMonths ?? undefined,
                creditYears: quotation.creditYears ?? undefined,
                creditDueDate: quotation.creditDueDate ?? undefined,
            }
            : null,

        // ==========================
        // 🔹 Discounts
        // ==========================

        itemsDiscountTotal:
            quotation.itemsDiscountTotal ?? 0,

        globalDiscountPercent:
            quotation.globalDiscountPercent ?? 0,

        globalDiscountTarget:
            quotation.globalDiscountTarget ?? 'PRODUCTS',

        globalDiscountAmount:
            quotation.globalDiscountAmount ?? 0,

        // ==========================
        // 🔹 Totals
        // ==========================

        total:
            quotation.total ?? 0,

        // ==========================
        // 🔹 Items
        // ==========================

        items:
            quotation.items ?? []

    };

};